import { CSSProperties, useRef } from 'react';

import { DateItem } from '../DateItem';

import styles from './DatesCarousel.module.scss';
import { DatesCarouselProps } from './interfaces';

const DatesCarousel = ({
  timeStamps,
  selectedDate,
  setSelectedDate,
}: DatesCarouselProps) => {
  const timeStampMapRef = useRef<Map<string, HTMLDivElement>>(new Map());

  const handleClick = (timeStamp: string) => () => {
    setSelectedDate(timeStamp);
  };

  const handleRenderDateItem =
    (timeStamp: string) => (node: Nullable<HTMLDivElement>) => {
      if (!node) {
        timeStampMapRef.current.delete(timeStamp);
        return;
      }

      timeStampMapRef.current.set(timeStamp, node);
    };

  const calculateIndicatorPosition = (): CSSProperties => {
    const defaultResult = { '--indicator-position': 0 } as CSSProperties;

    if (!selectedDate) {
      return defaultResult;
    }

    const node = timeStampMapRef.current.get(selectedDate);

    if (!node) {
      return defaultResult;
    }

    return {
      '--indicator-position': `${node.offsetLeft}px`,
      '--indicator-width': `${node.offsetWidth}px`,
    } as CSSProperties;
  };

  return (
    <div className={styles.root}>
      <div className={styles.inner} style={calculateIndicatorPosition()}>
        {timeStamps.map((timeStamp) => (
          <DateItem
            timeStamp={timeStamp}
            key={timeStamp}
            onClick={handleClick(timeStamp)}
            selected={timeStamp === selectedDate}
            ref={handleRenderDateItem(timeStamp)}
          />
        ))}
      </div>
    </div>
  );
};

export default DatesCarousel;
